import { FC, ReactNode } from 'react'
import { Select } from '@cargomart/ui'
import cn from 'classnames'

import { OrderFilterDateRange } from './OrderFilterDateRange'

import s from './OrderFilterSelect.module.less'

export interface OrderFilterDateSelectProps {
  departureDateFrom: string | null | undefined
  departureDateTo: string | null | undefined
  isLaptop: boolean
  label: ReactNode
  mobileSearchFields: ReactNode
  onPickFrom: (date: string) => void
  onPickTo: (date: string) => void
}

export const OrderFilterDateSelect: FC<OrderFilterDateSelectProps> = ({
  isLaptop,
  departureDateFrom,
  departureDateTo,
  label,
  onPickFrom,
  onPickTo,
  mobileSearchFields
}) =>
  isLaptop ? (
    mobileSearchFields
  ) : (
    <Select
      className={cn(s.filterSelect, departureDateFrom || departureDateTo ? s.filterSelectActive : '')}
      fullscreenName="Погрузка"
      isFullscreen={isLaptop}
      maxOptionListWidth={252}
      prefix={label}
    >
      <OrderFilterDateRange
        departureDateFrom={departureDateFrom}
        departureDateTo={departureDateTo}
        isLaptop={isLaptop}
        onPickFrom={onPickFrom}
        onPickTo={onPickTo}
      />
    </Select>
  )
